import Parse from "parse";
import debug from "src/modules/debug-logger";

export default async function clearParseSession() {
  try {
    if (Parse.User.current()) {
      await Parse.User.logOut();
    }
  } catch (err) {
    if (err.code === Parse.Error.INVALID_SESSION_TOKEN) {
      debug.auth("Clearing Parse session with logOut(), expected error.");
      return;
    }
    throw err;
  }
}
